export const packageTypeFull = {
  OPG: "Open Gym",
  CLS: "Class",
  PRI: "Private",
  PRG: "Private Group",
  FREE: "FREE REDEEM",
};

export const packageDurationFull = {
  "1T": "1 Time",
  "1D": "1 Day",
  "5D": "5 Days",
  "10D": "10 Days",
  "20D": "20 Days",
  "1W": "1 Week",
  "1M": "1 Month",
  "3M": "3 Months",
  "6M": "6 Months",
  "12M": "12 Months",
  "1S": "1 Session",
  "12S": "12 Sessions",
  "24S": "24 Sessions",
  "10S": "10 Sessions",
  "20S": "20 Sessions",
  "48S": "48 Sessions",
  "6MSUB": "6 Months - Subscription",
  "12MSUB": "12 Months - Subscription",
  "CUSTOM": "Custom Periods",
};

export const packageDurationAbbri = {
  "1T": "1 Time",
  "1D": "1 Day",
  "5D": "5 Days",
  "10D": "10 Days",
  "20D": "20 Days",
  "1W": "1 Week",
  "1M": "1 Mo",
  "3M": "3 Mo",
  "6M": "6 Mo",
  "12M": "12 Mo",
  "1S": "1",
  "12S": "12",
  "24S": "24",
  "10S": "10",
  "20S": "20",
  "48S": "48",
  "6MSUB": "6 Mo - Sub",
  "12MSUB": "12 Mo - Sub",
  "CUSTOM": "Custom",
};

export function getPackageFull(str) {
  let p = str.split(" ");
  let type = packageTypeFull[p[0]];
  let duration = packageDurationFull[p[1]];
  return type + " " + duration;
  //return $date.toJSON().slice(0, 10);
}